

















import { Vue, Component, Watch } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import SocialRewardsDescription from '../../../organisms/SocialRewards/SocialRewardsDescription.vue';

import eventBus from '@/utils/eventBus';

@Component({
  components: {
    CloseModalIcon,
    Surface,
    SocialRewardsDescription
  }
})
export default class SocialRewardsModal extends Vue {
  created() {
    document.onkeydown = this.handleOnkeydown;
  }

  @Watch('$route')
  onRouteChange() {
    this.onClose();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  handleOnkeydown({ key }: KeyboardEvent) {
    if (key === 'Escape') {
      this.onClose();
    }
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }
}
